import { RouterProvider } from 'react-router'
import { QueryClientProvider } from '@tanstack/react-query'
import { ThemeProvider } from '@provendoro/ui'
import { AuthProvider } from './features/auth/AuthProvider.js'
import { queryClient } from './lib/query-client.js'
import { router } from './router.js'
import { lazy, Suspense } from 'react'

const OfflineBanner = lazy(() => import('./components/pwa/OfflineBanner.js'))
const InstallPrompt = lazy(() => import('./components/pwa/InstallPrompt.js'))

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <AuthProvider>
          <Suspense fallback={null}>
            <OfflineBanner />
          </Suspense>
          <RouterProvider router={router} />
          <Suspense fallback={null}>
            <InstallPrompt />
          </Suspense>
        </AuthProvider>
      </ThemeProvider>
    </QueryClientProvider>
  )
}
